export default __webpack_public_path__ + "static/media/Layer_7@2x.6a2c8720.png";